var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58579 1.25241C2.96086 0.87734 3.46957 0.666626 4 0.666626H8.66667C8.84348 0.666626 9.01305 0.736864 9.13807 0.861888L13.8047 5.52855C13.9298 5.65358 14 5.82315 14 5.99996V13.3333C14 13.8637 13.7893 14.3724 13.4142 14.7475C13.0391 15.1226 12.5304 15.3333 12 15.3333H4C3.46957 15.3333 2.96086 15.1226 2.58579 14.7475C2.21071 14.3724 2 13.8637 2 13.3333V2.66663C2 2.13619 2.21071 1.62749 2.58579 1.25241ZM4 1.99996C3.82319 1.99996 3.65362 2.0702 3.5286 2.19522C3.40357 2.32025 3.33333 2.48981 3.33333 2.66663V13.3333C3.33333 13.5101 3.40357 13.6797 3.5286 13.8047C3.65362 13.9297 3.82319 14 4 14H12C12.1768 14 12.3464 13.9297 12.4714 13.8047C12.5964 13.6797 12.6667 13.5101 12.6667 13.3333V6.2761L8.39052 1.99996H4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66667 0.666626C9.03486 0.666626 9.33333 0.965103 9.33333 1.33329V5.33329H13.3333C13.7015 5.33329 14 5.63177 14 5.99996C14 6.36815 13.7015 6.66663 13.3333 6.66663H8.66667C8.29848 6.66663 8 6.36815 8 5.99996V1.33329C8 0.965103 8.29848 0.666626 8.66667 0.666626Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.e2b7e4f63740cbbf94ec99e49104286f.svg";
export { ForwardRef as ReactComponent };